import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { ContactComponent } from '../../components/contact/contact.component';

@Injectable({
    providedIn: 'root'
})
export class ContactEditGuard implements CanDeactivate<ContactComponent> {
    canDeactivate(component: ContactComponent): Observable<boolean> | Promise<boolean> | boolean {
        if (component.contactDetailComponent.contactForm.touched && component.contactDetailComponent.contactForm.dirty) {
            return confirm(`Are you sure you want to navigate away and discard your changes?`);
        }
        return true;
    }
}
